import axios, { getData } from "lib/axios";
import { useQuery } from "react-query";

export const useGetEmployeeEntitlement = () =>
  useQuery("entitlement", async () => {
    const res = await axios.get(`/entitlement`).then(getData);
    return res.data;
  });
